const NEWS_STORAGE_KEY = 'news';

export function getStoredNewsIds(): number[] {
  const storedNews = localStorage.getItem(NEWS_STORAGE_KEY);

  if (!storedNews || storedNews === 'undefined') {
    return [];
  }

  try {
    const parsedNews = JSON.parse(storedNews);
    return Array.isArray(parsedNews)
      ? parsedNews.filter((id): id is number => typeof id === 'number')
      : [];
  } catch {
    return [];
  }
}

export function storeNewsIds(newsIds: number[]): void {
  localStorage.setItem(NEWS_STORAGE_KEY, JSON.stringify(newsIds));
}
